export default {
  title: 'User Login',
  username: 'Please enter the user name',
  password: 'Please enter your password',
  login: 'Login',
  forgetPass: 'forget the password ',
  resources: 'Download resources',
  retrievePass: 'Retrieve password',
  phone: 'Please enter the phone',
  newpass: 'Please enter the new password',
  RepeatPass: 'Please repeat the password',
  submit: 'submit',
  return: 'Return to the login',
  VerificationBy: 'Verification by',
  slide: 'Drag the slider to verify',
  qdtc: 'You are sure to log out. Do you want to continue?',
  getCode: 'TestGetCode',
  errLog: 'Whether to export server logs',
  keycode: "Please enter the verification code",
  systemVersion: "system version",
  show: "show"
}



// WEBPACK FOOTER //
// ./src/assets/i18n/en/Login.js